// @flow
import PushEvent from 'components/pushevent/PushEvent';
import { connect } from 'react-redux';

import type { StateType } from 'types/Actions';
import type { StateProps } from 'components/pushevent/PushEvent';

export default connect(
    (state: StateType): StateProps => ({
      pushevent: state.settingsState.home_push_event,
      userPref: state.userState.userPref,
    }),
)(PushEvent);
